import { createAsyncThunk } from "@reduxjs/toolkit";
import { BrokerConfigurationState, PayloadRequest } from "./state";
import { RootState } from "../RootState";
import { getBrokerAnalizis, getBrokerConfiguration, getBrokerProperties, saveBrokerConfiguration } from "src/apis/brokersConfigurations/brokersConfigurationApi";
import { initialBrokerConfigurationState } from "./slice";

export const fetchBrokerProperties = createAsyncThunk<
    BrokerConfigurationState,
    PayloadRequest,
    {
        state: RootState;
    }
>('broker_configuration/fetchBrokerProperties', async (payload: PayloadRequest, thunkAPI) => {
    const store: RootState = thunkAPI.getState();
    const { token } = store.User;
    const clonePayload = { ...payload }
    const brokersProperties = await getBrokerProperties(payload, token);
    if (brokersProperties.error) {
        if (brokersProperties.error === 'AbortError') {
            return {
                error: 'AbortError'
            }
        } else {
            return {
                error: 'No hay datos.'
            }
        }
    }
    if (clonePayload.filter) {
        return {
            brokersProperties,
            brokersPropertiesFiltered: brokersProperties,
            filter: clonePayload.filter
        };
    }
    try {
        const actualBrokerConfiguration = await getBrokerConfiguration(brokersProperties.user_id, token);
        return {
            brokersProperties,
            actualBrokerConfiguration,
            brokersPropertiesFiltered: initialBrokerConfigurationState.brokersPropertiesFiltered,
            filter: clonePayload.filter
        }
    } catch (error) {
        return {
            brokersProperties,
            brokersPropertiesFiltered: initialBrokerConfigurationState.brokersPropertiesFiltered,
            filter: clonePayload.filter
        }
    }

});

export const saveBrokerConfigurationThunk = createAsyncThunk<
    BrokerConfigurationState,
    PayloadRequest,
    {
        state: RootState;
    }
>('broker_configuration/saveBrokersConfigurations', async (payload: PayloadRequest, thunkAPI) => {
    const store: RootState = thunkAPI.getState();
    const { token } = store.User;
    const response = await saveBrokerConfiguration(payload, token);
    return response;
});
export const fetchBrokerAnalizisThunk = createAsyncThunk<
    BrokerConfigurationState,
    PayloadRequest,
    {
        state: RootState;
    }
>('broker_configuration/fetchBrokerAnalizisThunk', async (payload: PayloadRequest, thunkAPI) => {
    const store: RootState = thunkAPI.getState();
    const { token } = store.User;
    const response = await getBrokerAnalizis(payload, token);
    return response;
});
